// At rail width the project art is too small to read — the screenshots in
// particular land as texture rather than content. Clicking a plate opens the
// image near full-screen instead. The trigger is built here rather than
// written into projects.erb so that the plate degrades to a plain picture when
// this script doesn't run.

const PLATE_ART = ".project__plate img"

function buildLightbox() {
  const lightbox = document.createElement("dialog")
  lightbox.className = "lightbox"
  lightbox.innerHTML = `
    <div class="lightbox__frame">
      <img class="lightbox__image" alt="" />
      <button class="lightbox__close" type="button" aria-label="Close">&times;</button>
    </div>
  `

  // Esc closes on its own once the dialog is modal. A click landing on the
  // dialog itself rather than the frame inside it is a click on the backdrop.
  lightbox.addEventListener("click", (event) => {
    if (event.target === lightbox) lightbox.close()
  })
  lightbox.querySelector(".lightbox__close").addEventListener("click", () => lightbox.close())

  document.body.append(lightbox)
  return lightbox
}

function enlarge(lightbox, art) {
  const enlarged = lightbox.querySelector(".lightbox__image")
  enlarged.src = art.currentSrc || art.src
  enlarged.alt = art.alt
  // The enlarged copy has to carry the marker too, or the diagram would invert
  // on the page and then show up un-inverted at full size.
  enlarged.classList.toggle(
    "project__art--on-white",
    art.classList.contains("project__art--on-white")
  )
  lightbox.showModal()
}

function makeZoomable(lightbox, art) {
  const trigger = document.createElement("button")
  trigger.type = "button"
  trigger.className = "project__zoom"
  trigger.setAttribute("aria-label", "Enlarge image")

  art.replaceWith(trigger)
  trigger.append(art)
  trigger.addEventListener("click", () => enlarge(lightbox, art))
}

document.addEventListener("DOMContentLoaded", () => {
  const plateArt = document.querySelectorAll(PLATE_ART)
  if (plateArt.length === 0) return

  const lightbox = buildLightbox()
  plateArt.forEach((art) => makeZoomable(lightbox, art))
})
